import React from 'react';
import { Layout } from 'antd';
import { MainContainer } from '../../Components/Atoms/MainContainer';

export const Dashboard = () => {
  return (
    <Layout className="screen">
      <MainContainer />
    </Layout>
  );
};
